import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import ActorAccessorySet from '../../../domain/entities/ActorAccessorySet';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexActorAccessorySetsSuccess: {
      const result = action.payload as PaginatedResult<ActorAccessorySet>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
